import {Component, ViewEncapsulation, OnInit, Inject, ViewChild} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AppService} from '@irb/app.service';
import {IrbClientsService} from '@irb/irb-clients/irb-clients.service';
import {IrbEditorsEvents} from '@irb-common/events';
import {DropdownFilterComponent} from '@irb/irb-common/components/dropdown-filter/dropdown-filter.component';
import {IDropdownItem} from '@irb/irb-common/models/dropdown.model';

@Component({ standalone: false,
    selector: 'loss-priority-settings-dialog',
    templateUrl: './loss-priority-settings-dialog.component.html',
    styleUrls: ['./loss-priority-settings-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LossPrioritySettingsDialogComponent implements OnInit {
    @ViewChild('IrbSelectedLossTypeDropdown') selectReference: DropdownFilterComponent;
    file: any;
    hasFile: boolean = false;
    isValidFile: boolean = false;
    errorMessage: string;
    selectedAmount: any;
    selectedLossPriority: IDropdownItem = null;
    lossTypeDropdown: IDropdownItem[] = [];

    constructor(
        public dialogRef: MatDialogRef<LossPrioritySettingsDialogComponent>,
        public as: AppService,
        public cs: IrbClientsService,
        @Inject(MAT_DIALOG_DATA) public mdd: any
    ) {
        this.lossTypeDropdown = [
            {
                name: "Use Long Term losses only to meet the target",
                value: "Use Long Term losses only to meet the target",
            },
            {
                name: "Use Short Term losses only to meet the target",
                value: "Use Short Term losses only to meet the target",
            },
            {
                name: "Use Short, then long term losses to meet the target",
                value: "Use Short, then long term losses to meet the target",
            },
            {
                name: "Use all losses, prioritizing from the largest $ loss first to minimize trades",
                value: "Use all losses, prioritizing from the largest $ loss first to minimize trades",
            },
        ];
    }

    ngOnInit() {
    }

    setChainTypeOptions() {
        this.selectReference.set(this.lossTypeDropdown);
    }

    close() {
        this.dialogRef.close();
    }

    onFileChange(event: any) {
        this.file = event.target.files[0];
        this.hasFile = true;
        this.isValidFile = this.file.name.endsWith('.csv');
    }

    onAmountChange() {
        if (this.selectedAmount) {
            if (!this.selectedLossPriority)
                this.selectedLossPriority = this.lossTypeDropdown[3];
        } else {
            this.selectedLossPriority = null;
        }
    }

    submitFile() {
        if (this.selectedLossPriority && this.selectedAmount && this.selectedAmount != "") {
            this.as.fireEvent(IrbEditorsEvents.REFRESH_HARVEST_TAX_LOSS_GRID, {
                amount: this.selectedAmount,
                lossPriority: this.selectedLossPriority.value,
                data: this.mdd.data
            });
        } else {
            this.as.fireEvent(IrbEditorsEvents.REFRESH_HARVEST_TAX_LOSS_GRID, {
                amount: this.selectedAmount,
                lossPriority: undefined,
                data: this.mdd.data
            });
        }
        this.close();
    }
}
